<template>
  <h1>Legal</h1>
</template>
